import { combineEpics } from 'redux-observable';
import { removeClientEpic } from './_epic/removeClient.epic';
import { updateClientEpic } from './_epic/updateClient.epic';

export const clientEpic = combineEpics(
  removeClientEpic,
  updateClientEpic,
);
